













import Vue from "vue";

export default Vue.extend({
  name: 'ActionsDropdown',
  props: {
    showActions: { type: Boolean, required: true },
    actions: { type: Array, required: true },
    top: { type: Number, required: false, default: null },
    left: { type: Number, required: false, default: null },
    right: { type: Number, required: false, default: null },
    bottom: { type: Number, required: false, default: null },
    noBorder: { type: Boolean, required: false, default: true }
  },
  computed: {
    positionStyle(): any {
      return {
        top: this.getPosition(this.top),
        left: this.getPosition(this.left),
        right: this.getPosition(this.right),
        bottom: this.getPosition(this.bottom)
      };
    }
  },
  methods: {
    getPosition(position?: number): string {
      if (position || position === 0) {
        return `${position}px`;
      }
      return 'auto';
    }
  }
})



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/componentsReusable/dropdowns/ActionsDropdown.vue